const api_endpoint = import.meta.env.VITE_API_ENDPOINT;

export { api_endpoint };
